import React, {Component} from 'react';
import i18 from '../../i18';
import {supplierRuleApi} from '../../api';

class SupplierRules extends Component {

    getCompanyId = () => {
        return this.props.config.company_id;
    };

    getErrorMessage = (error, fallbackMessage) => {
        if (
            error
            && error.response
            && error.response.data
        ) {
            const responseData = error.response.data;

            if (
                responseData.error
                && responseData.error.message
            ) {
                return responseData.error.message;
            }

            if (responseData.message) {
                return responseData.message;
            }
        }

        return fallbackMessage;
    };

    removeRule = async (rule) => {
        if (!window.confirm('Biztos törölni szeretné a szabályt?')) {
            return;
        }

        try {
            const data = await supplierRuleApi.remove(
                this.getCompanyId(),
                rule.id,
            );

            this.props.updateRules(
                data.supplierRules,
            );

            this.props.notifySuccess('A szabály törlése sikeres.');
        } catch (error) {
            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'A szabály törlése sikertelen.',
                ),
            );
        }
    };

    removeAllRules = async () => {
        if (
            !window.confirm(
                'Biztos törölni szeretné az összes szabályt?',
            )
        ) {
            return;
        }

        try {
            const data = await supplierRuleApi.removeAll(
                this.getCompanyId(),
            );

            this.props.updateRules(
                data.supplierRules,
            );

            this.props.notifySuccess(
                'Az összes szabály törölve lett.',
            );
        } catch (error) {
            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'A szabályok törlése sikertelen.',
                ),
            );
        }
    };

    renderValue = (value) => {
        if (
            value === null
            || typeof value === 'undefined'
            || value === ''
        ) {
            return '-';
        }

        return value;
    };

    renderVat = (vat) => {
        if (
            vat === null
            || typeof vat === 'undefined'
            || vat === ''
        ) {
            return '-';
        }

        return vat + '%';
    };

    renderRulesTableHeader = () => {
        return (
            <tr>
                <th>{i18.COMMON._identifier}</th>
                <th>{i18.SUPPLIER._supplierName}</th>
                <th>{i18.SUPPLIER._typeOfTraffic}</th>
                <th>{i18.SUPPLIER._positionNumberCountry}</th>
                <th>{i18.SUPPLIER._orderNumberStat}</th>
                <th>{i18.SUPPLIER._mainBookNumber}</th>
                <th>{i18.SUPPLIER._VAT}</th>
                <th>{i18.SUPPLIER._collectorCode}</th>
                <th>{i18.SUPPLIER._taxNumber}</th>
                <th>{i18.COMMON._typeOfRule}</th>
                <th>{i18.COMMON._position}</th>
                <th>{i18.COMMON._updatedAt}</th>
                <th style={{width: '70px'}}/>
            </tr>
        );
    };

    renderRulesTableRow = (rule) => {
        return (
            <tr key={rule.id}>
                <td>#{rule.id}</td>
                <td>{this.renderValue(rule.supplier_name)}</td>
                <td>{this.renderValue(rule.item_name)}</td>
                <td>{this.renderValue(rule.position_number_country)}</td>
                <td>{this.renderValue(rule.order_number_stat)}</td>
                <td>{this.renderValue(rule.main_bookkeeping_number)}</td>
                <td>{this.renderVat(rule.vat)}</td>
                <td>{this.renderValue(rule.vat_collector_code)}</td>
                <td>{this.renderValue(rule.vat_degree)}</td>
                <td>{this.renderValue(rule.type_label)}</td>
                <td>{this.renderValue(rule.position)}</td>
                <td>{this.renderValue(rule.updated_at)}</td>
                <td>
                    <button
                        type="button"
                        className="btn btn-link p-0 mr-2"
                        title={i18.SUPPLIER._editRule}
                        onClick={() => this.props.editRule(rule)}
                    >
                        <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                        />
                    </button>

                    <button
                        type="button"
                        className="btn btn-link p-0"
                        title={i18.SUPPLIER._deleteRule}
                        onClick={() => this.removeRule(rule)}
                    >
                        <i
                            className="fa fa-trash-o"
                            aria-hidden="true"
                        />
                    </button>
                </td>
            </tr>
        );
    };

    renderRulesTable = () => {
        const {supplierRules} = this.props;

        if (
            !supplierRules
            || supplierRules.length === 0
        ) {
            return (
                <p className="text-center">
                    Nincs megjeleníthető szabály.
                </p>
            );
        }

        return (
            <table className="table table-striped table-aibook-no-border">
                <thead>
                {this.renderRulesTableHeader()}
                </thead>

                <tbody>
                {supplierRules.map(
                    this.renderRulesTableRow,
                )}
                </tbody>
            </table>
        );
    };

    render() {
        return (
            <section id="supplier-rules">
                <div className="header">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1>
                                    <a
                                        onClick={this.props.toggleRulesPage}
                                        className="choose-btn"
                                    >
                                        {i18.BUTTONS._back}
                                    </a>

                                    {i18.SUPPLIER._rulesTitle}
                                </h1>
                            </div>

                            <div className="col-12">
                                <p>
                                    {
                                        i18.SUPPLIER
                                            ._rulesDescription
                                    }
                                </p>

                                <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    onClick={
                                        this.removeAllRules
                                    }
                                >
                                    <i
                                        className="fa fa-trash-o"
                                        aria-hidden="true"
                                    />
                                    &nbsp;
                                    {
                                        i18.COMMON
                                            ._deleteAllRules
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                {this.renderRulesTable()}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default SupplierRules;


// WEBPACK FOOTER //
// ./src/components/supplier/SupplierRules.js